import React, { useContext, useState, useEffect, useRef } from 'react'

import FullScreenPopup from '@/product/components/organisms/FullScreenPopup'
import InvoiceContext from '@/product/context/invoice/invoiceContext'
import CustomCommonContext from '@/custom/context/common/commonContext'
import { handleRedirectInternal, mapData } from '@/product/common/components'

import {
    dateFormatFunction,
    dateTimeFormatFunction,
    currencyFormat,
    capitalize,
    paymentTypeRosoom,
} from '@/custom/common/components'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import { Button, Divider, Menu, MenuItem } from '@mui/material'
import { LOGO, SITE_NAME } from '@/utils/UI/index'
import { useReactToPrint } from 'react-to-print'
import bwipjs from 'bwip-js'
import PropTypes from 'prop-types'
import AppBar from '@mui/material/AppBar'
import Tabs from '@mui/material/Tabs'
import Tab from '@mui/material/Tab'
import RefundInvoice from '@/custom/components/organisms/RefundInvoice'
import CustomDialog from '@/product/components/organisms/Dialog'
import SettingContext from '@/product/context/setting/settingContext'
import PrimaryButton from '@/product/components/atoms/PrimaryButton'
import CartContext from '@/product/context/cart/cartContext'
import AuthContext from '@/product/context/auth/authContext'
import Loaders from '@/product/components/molecules/Loaders'
import Layout from '@/product/components/templates/Layout'
import { useHistory } from 'react-router-dom'
import CartItem from '@/views/Invoice/cartItem'
// import ShipmentTracking from '@/views/ShipmentTracking'

function TabPanel(props) {
    const { children, value, index, ...other } = props

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <div>
                    <>{children}</>
                </div>
            )}
        </div>
    )
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
}

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    }
}

const InvoiceComponent = ({ props }) => {
    console.log(props, 'propsCheck')

    const customCommonContext = useContext(CustomCommonContext)
    const authContext = useContext(AuthContext)
    const { allConfigurationVariables } = customCommonContext
    const [disable, setDisable] = useState(false)

    const invoiceContext = useContext(InvoiceContext)
    const cartContext = useContext(CartContext)
    const settingcontext = useContext(SettingContext)

    const {
        searchTableAction,
        searchTableFetch,
        search_fetch_data,
        responseStatus: responseStatusSetting,
        clearResponse: clearResponseCommuncation,
    } = settingcontext
    const { user } = authContext
    const {
        single_invoice,
        getSingleInvoice,
        all_invoices,
        changeProductStatus,
        responseStatus: responseStatusInvoice,
    } = invoiceContext
    const { payCartsOffline, responseStatus: responseStatusCart } = cartContext

    const [viewContent, setViewContent] = useState(null)
    const [isLoading, setIsLoading] = useState(true)
    const [printId, setPrintId] = useState({ id: '0' })
    const [print, setPrint] = useState(false)
    const [intialPickedupLoad, setIntialPickedupLoad] = useState(false)
    const [changeStatus, setChangeStatus] = useState(false)
    const [invoiceNotesStatus, setInvoiceNotesStatus] = useState(false)
    const history = useHistory()

    const data = props.data
    let invoiceID =
        props.winnerInvoiceId ||
        (props.match?.params?.id ? props.match.params.id : 0)
    let userId =
        props.winnerUserId ||
        (props.match?.params?.uid ? props.match.params.uid : 0)
    const toggleFullScreenPopup = props.function

    const [manageTracking, setManageTracking] = useState({
        popup: false,
        status: 'new',
        data: null,
    })

    const toggleTrackingPopup = (popup, status, data) => {
        if (popup) {
            setManageTracking({ popup, status, data })
        } else {
            setManageTracking({ popup, status: 'new', data: null })
        }
    }
    const [manageRefund, setManageRefund] = useState({
        popup: false,
        status: 'new',
        data: null,
    })

    const toggleRefundPopup = (popup, status, data) => {
        if (popup) {
            setManageRefund({ popup, status, data })
        } else {
            setManageRefund({ popup, status: 'new', data: null })
        }
    }

    const [changeTrackingStatus, setChangeTrackingStatus] =
        React.useState(false)

    const changeChangeStatus = () => {
        setChangeStatus(!changeStatus)
    }
    const changeChangeTrackStatus = () => {
        setChangeTrackingStatus(!changeTrackingStatus)
    }

    const toggleInvoiceModal = () => {
        setInvoiceNotesStatus(!invoiceNotesStatus)
    }

    const formik = useFormik({
        initialValues: {
            cart_id: 0,
        },
        validateOnBlur: false,
    })

    const onClickRefundInvoice = (id, secondaryID) => {
        toggleRefundPopup(true, 'view', {
            id,
            user_id: secondaryID,
            admin_id: props.userId,
        })
    }

    // temp lang Manager
    const t = (text) => {
        text = text.charAt(0).toUpperCase() + text.slice(1)
        return text.replace(/_/g, ' ')
    }

    useEffect(() => {
        resetFrom()
    }, [props])

    // useEffect(() => {
    //     console.log(props.data, 'propingg')
    //     setPrintId({ id: props.data.id })
    //     // handlePrint()
    // }, [props.data])\

    const viewTrack = (file) => {
        let newWindow = null
        newWindow = window.open(
            `https://www.ups.com/track?track=yes&trackNums=${file}&loc=en_US&requester=ST/`,
            '_blank',
            'noopener,noreferrer'
        )
        if (newWindow) newWindow.opener = null
    }

    useEffect(() => {
        // if (data.status === 'edit' || data.status === 'view') {
        console.log(userId, 'uerrr')
        setIsLoading(true)
        if (invoiceID && userId) {
            formik.values.invoice_id = invoiceID
            formik.values.user_id = userId
            getSingleInvoice(formik.values, 'viewInvoice')
        }

        // formik.values.user_id = data.sid
        // if (data.action === 'cancel') {
        //     formik.values.filters = {
        //         active: {
        //             type: 'in',
        //             field: 'b.active',
        //             value: 2,
        //         },
        //     }
        // } else {
        //     formik.values.filters = {
        //         active: {
        //             type: 'notin',
        //             field: 'b.active',
        //             value: 2,
        //         },
        //     }
        // }

        // } else {
        //     resetFrom()
        // }
    }, [invoiceID, userId])
    let [invoiceDetails, setInvoiceDetails] = useState({
        invoiceProducts: [],
        cartValues: {},
        appointmentDetail: {},
        locationDetail: {},
        invoiceTransactions: [],
        invoiceUser: [],
        invoiceAddress: [],
    })

    useEffect(() => {
        if (single_invoice && single_invoice.from === 'viewInvoice') {
            setInvoiceDetails({
                invoiceProducts: single_invoice.invoicerecords.length
                    ? single_invoice.invoicerecords
                    : [],
                cartValues: single_invoice.cartvalues,
                appointmentDetail: single_invoice.appointmentrecord,
                locationDetail: single_invoice.locationrecord,
                invoiceTransactions: single_invoice.transactionrecords,
                invoiceUser: single_invoice.invoiceuserrecord,
                invoiceAddress: single_invoice.invoiceaddressrecord,
            })
            console.log('hello')
            // formikCheckbox.values.picked_up = single_invoice.invoicerecords[0]
            //     .delivered
            //     ? true
            //     : false
        }
    }, [single_invoice])

    useEffect(() => {
        if (responseStatusSetting) {
            if (responseStatusSetting.status === 'success') {
                if (
                    responseStatusSetting.from === 'third_shipping_shipstation'
                ) {
                    setChangeTrackingStatus(false)
                    resetTracking()
                    getSingleInvoice(formik.values, 'viewInvoice')
                }
            }
            setDisable(false)
        }
    }, [responseStatusSetting])

    useEffect(() => {
        if (invoiceDetails.invoiceProducts.length) {
            setIsLoading(false)
        }
    }, [invoiceDetails])

    useEffect(() => {
        setInvoiceDetails({
            invoiceProducts: [],
            cartValues: {},
            appointmentDetail: {},
            locationDetail: {},
            invoiceTransactions: [],
            invoiceUser: [],
            invoiceAddress: [],
        })
        return () => {
            setInvoiceDetails({
                invoiceProducts: [],
                cartValues: {},
                appointmentDetail: {},
                locationDetail: {},
                invoiceTransactions: [],
                invoiceUser: [],
                invoiceAddress: [],
            })
        }
    }, [])

    useEffect(() => {
        if (responseStatusInvoice) {
            if (
                responseStatusInvoice.status === 'success' &&
                responseStatusInvoice.from === 'productchange'
            ) {
                setChangeStatus(false)
                getSingleInvoice(formik.values, 'viewInvoice')
            }
        }
    }, [responseStatusInvoice])
    const resetFrom = () => {
        setViewContent(null)
    }

    const ref = React.createRef()
    const options = {}

    const generatePDF = (toPdf) => {
        setPrint(true)
        toPdf()
    }
    const completedPDF = () => {
        setPrint(false)
    }

    const [anchorEl, setAnchorEl] = React.useState(null)

    const handleMenuClick = (event) => {
        setAnchorEl(event.currentTarget)
    }

    const handleMenuClose = () => {
        setAnchorEl(null)
    }

    const formikSelection = useFormik({
        initialValues: {
            action: '',
            project_id: '',
            auction_id: '',
            notes: '',
            payment_method: '',
            isPaymentasPaid: false,
        },
        validationSchema: Yup.object({
            notes: Yup.string().when('action', {
                is: 'cancel',
                then: Yup.string().required('Required!'),
            }),
            payment_method: Yup.string().when('action', {
                is: 'paid',
                then: Yup.string().required('Required!'),
            }),
        }),
        onSubmit: (values) => {
            if (
                values.payment_method === 'manual' ||
                values.action === 'unpaid' ||
                values.action === 'cancel'
            ) {
                setIsLoading(true)
                changeProductStatus(values)
            } else {
                values.invoice_id = []
                values.pay_type = 'auction'
                values.user_id = 1
                values.project_id.forEach((id) => {
                    all_invoices.records.forEach((curr) => {
                        if (curr.id === id)
                            values.invoice_id.push(curr.common_invoice)
                    })
                })

                setIsLoading(true)
                payCartsOffline(values)
            }
        },
    })

    const formikNotesSelection = useFormik({
        initialValues: {
            invoice_notes: '',
        },
        validationSchema: Yup.object({
            invoice_notes: Yup.string().required('Required'),
        }),
        onSubmit: (values) => {
            console.log(values, 'checkValues')
        },
    })

    // useEffect(() => {
    //     try {
    //         if (printId) {
    //             console.log(props.data.id, 'iooo')
    //             let canvas = bwipjs.toCanvas('mycanvas', {
    //                 bcid: 'code128',
    //                 text: printId.id.toString(),
    //                 // scale: 8,
    //                 width: 50,
    //                 height: 15,
    //                 includetext: true,
    //                 textxalign: 'center',
    //             })
    //         }
    //     } catch (e) {
    //         console.log(e, 'error!')
    //     }
    // }, [printId.id])

    const formikCheckbox = useFormik({
        initialValues: {
            picked_up: false,
        },
        onSubmit: (values) => {
            console.log('handle checked submit ', values)
        },
    })

    const paymentMethod = [
        {
            label: 'Payment Method',
            placeholder: 'Select a method',
            name: 'payment_method',
            type: 'select',
            options: [
                {
                    show: 'Manual',
                    value: 'manual',
                },
            ],
            defaultOptionValue: 'Select a method',
            formik: formikSelection,
        },
    ]

    const mapDataOptions = {
        formik: formikCheckbox,
        data: [
            {
                label: 'Mark Item as Picked Up',
                type: 'checkbox',
                class: 'col-12',
                name: 'picked_up',
            },
        ],
    }

    const formikTracking = useFormik({
        initialValues: {
            tracking: '',
            id: [],
            table: 'third_shipping_shipstation',
        },
        validationSchema: Yup.object({
            tracking: Yup.string()
                .matches(/^[0-9]*$/g, 'Only numbers are allowed')
                .required('Required'),
        }),
        onSubmit: (values) => {
            console.log(values, 'checkValues')
            setDisable(true)
            searchTableAction(values, false, 'third_shipping_shipstation')
        },
    })

    const trackingDetails = [
        {
            label: '',
            name: 'tracking',
            type: 'text',
            placeholder: 'Enter Tracking Id',
            formik: formikTracking,
        },
    ]

    // useEffect(() => {
    //     if (data.id) {
    //         let payload = {
    //             action: formikCheckbox.values.picked_up
    //                 ? 'delivered'
    //                 : 'undelivered',
    //             project_id: [invoiceDetails?.invoiceProducts[0]?.id],
    //         }
    //         if (intialPickedupLoad && payload.project_id[0]) {
    //             // changeProductStatus(payload)
    //         }

    //         setIntialPickedupLoad(true)
    //     }
    // }, [formikCheckbox.values.picked_up, data.id])
    const onClickTracking = (tracking, sid, type) => {
        if (tracking.length) {
            let id = []
            tracking.map((data) => {
                id.push(data.third_shipping_shipstation_id)
            })
            formikTracking.values.id = id
            setChangeTrackingStatus(true)
        }
    }

    const resetTracking = () => {
        formikTracking.values.id = 0
        formikTracking.values.tracking = ''
        formikTracking.handleReset()
    }

    const onSelectMultiProducts = (data, action) => {
        formikSelection.values.action = action
        formikSelection.values.project_id = [data]
        if (values.action == 'paid') {
            formikSelection.values.isPaymentasPaid = true
        } else {
            formikSelection.values.isPaymentasPaid = false
        }
        if (action === 'paid' || action === 'unpaid' || action === 'cancel') {
            setChangeStatus(true)
        }
    }

    const reasonForCancelInvoice = [
        {
            label: 'Reason *',
            name: 'notes',
            type: 'text',
            placeholder: 'Reason for cancellation',
            formik: formikSelection,
        },
    ]

    const invoiceNotes = [
        {
            label: 'Notes',
            name: 'invoice_notes',
            type: 'textarea',
            placeholder: 'Enter your invoice notes',
            formik: formikNotesSelection,
        },
    ]

    const [value, setValue] = useState(0)

    const handleChange = (newValue) => {
        setValue(newValue)
    }

    useEffect(() => {
        if (responseStatusCart) {
            if (responseStatusCart.status === 'success') {
                if (responseStatusCart.from === 'payCartsOffline') {
                    changeChangeStatus()
                    getSingleInvoice(formik.values, 'viewInvoice')
                }
            }
        }
    }, [responseStatusCart])

    const userRedirect = (data) => {
        if (data) {
            handleRedirectInternal(
                history,
                `buyer_profile/edit/${data.user_id}`
            )
        }
    }

    return (
        // <FullScreenPopup
        //     modaltitle={
        //         data.status === 'view' ? `VIEW INVOICE` : `EDIT INVOICE`
        //     }
        //     open={data.popup}
        //     handleClose={() => toggleFullScreenPopup(false)}
        // >
        <>
            <div className="">
                {' '}
                {isLoading ? (
                    <div className="fspLoader">
                        <Loaders isLoading={isLoading} />
                    </div>
                ) : (
                    <>
                        <div className="buyerDetailsTab invoicesTab">
                            {props.removeActions ? (
                                ''
                            ) : (
                                <div className="bdTop">
                                    <div className="bdUser">
                                        <h2>
                                            <span className="material-icons">
                                                receipt
                                            </span>
                                            {'Invoice'}{' '}
                                            {
                                                invoiceDetails.cartValues
                                                    .common_invoice
                                            }
                                        </h2>
                                    </div>
                                    <div>
                                        {value === 2 ? (
                                            <></>
                                        ) : // <Button
                                        //     id="invoice_report"
                                        //     variant="outlined"
                                        //     className="exportDownload"
                                        //     onClick={() =>
                                        //         getAllExportDownload({
                                        //             action: 'export',
                                        //             order: 'asc',
                                        //             orderby: '',
                                        //             search: 'all',
                                        //             report: `all_invoice_management`,
                                        //         })
                                        //     }
                                        // >
                                        //     <span className="material-icons-round">
                                        //         get_app
                                        //     </span>
                                        // </Button>
                                        null}
                                        {invoiceDetails?.invoiceProducts
                                            ?.length &&
                                        invoiceDetails?.invoiceProducts[0]
                                            ?.delivery_type === 'shipping' &&
                                        !invoiceDetails?.invoiceProducts[0]
                                            ?.third_shipping_shipstation_tracking &&
                                        invoiceDetails?.invoiceProducts[0]
                                            ?.paid ? (
                                            <>
                                                <Button
                                                    aria-controls="simple-menu"
                                                    aria-haspopup="true"
                                                    onClick={() =>
                                                        onClickTracking(
                                                            invoiceDetails?.invoiceProducts
                                                        )
                                                    }
                                                    className="mr-2"
                                                    variant="outlined"
                                                >
                                                    <span className="material-icons">
                                                        add
                                                    </span>
                                                    Add Tracking
                                                </Button>
                                                <Button
                                                    aria-controls="simple-menu"
                                                    aria-haspopup="true"
                                                    onClick={() =>
                                                        toggleTrackingPopup(
                                                            true,
                                                            'view',
                                                            invoiceDetails
                                                                ?.invoiceProducts[0]
                                                        )
                                                    }
                                                    className="mr-2"
                                                    variant="outlined"
                                                >
                                                    <span className="material-icons">
                                                        get_app
                                                    </span>
                                                    Get Tracking Info
                                                </Button>
                                            </>
                                        ) : null}

                                        <Button
                                            aria-controls="simple-menu"
                                            aria-haspopup="true"
                                            onClick={handleMenuClick}
                                            variant="outlined"
                                        >
                                            <span className="material-icons edit">
                                                edit
                                            </span>
                                            Edit
                                            <span className="material-icons down">
                                                expand_more
                                            </span>
                                        </Button>
                                        <Menu
                                            id="simple-menu"
                                            anchorEl={anchorEl}
                                            keepMounted
                                            open={Boolean(anchorEl)}
                                            onClose={handleMenuClose}
                                        >
                                            {invoiceDetails?.invoiceProducts
                                                .length &&
                                            invoiceDetails?.invoiceProducts[0]
                                                .paid ? (
                                                <>
                                                    <MenuItem
                                                        onClick={() => {
                                                            onClickRefundInvoice(
                                                                invoiceDetails
                                                                    .invoiceProducts[0]
                                                                    ?.common_invoice,
                                                                invoiceDetails
                                                                    ?.invoiceUser[0]
                                                                    ?.id
                                                            )
                                                            setAnchorEl(null)
                                                        }}
                                                    >
                                                        Return
                                                    </MenuItem>
                                                    <MenuItem
                                                        onClick={() => {
                                                            onSelectMultiProducts(
                                                                invoiceDetails
                                                                    .invoiceProducts[0]
                                                                    ?.id,
                                                                'unpaid'
                                                            )
                                                            setAnchorEl(null)
                                                        }}
                                                    >
                                                        Move to Unpaid
                                                    </MenuItem>
                                                </>
                                            ) : invoiceDetails?.invoiceProducts
                                                  .length &&
                                              invoiceDetails?.invoiceProducts[0]
                                                  .active == 2 ? (
                                                <MenuItem
                                                    onClick={() => {
                                                        onSelectMultiProducts(
                                                            invoiceDetails
                                                                .invoiceProducts[0]
                                                                ?.id,
                                                            'unpaid'
                                                        )
                                                        setAnchorEl(null)
                                                    }}
                                                >
                                                    Move to Unpaid
                                                </MenuItem>
                                            ) : (
                                                <>
                                                    {' '}
                                                    <MenuItem
                                                        onClick={() => {
                                                            onSelectMultiProducts(
                                                                invoiceDetails
                                                                    .invoiceProducts[0]
                                                                    ?.id,
                                                                'paid'
                                                            )
                                                            setAnchorEl(null)
                                                        }}
                                                    >
                                                        Move to Paid
                                                    </MenuItem>
                                                    {invoiceDetails
                                                        ?.invoiceProducts[0]
                                                        ?.active !== 2 ? (
                                                        <MenuItem
                                                            onClick={() => {
                                                                onSelectMultiProducts(
                                                                    invoiceDetails
                                                                        .invoiceProducts[0]
                                                                        ?.id,
                                                                    'cancel'
                                                                )
                                                                setAnchorEl(
                                                                    null
                                                                )
                                                            }}
                                                        >
                                                            Move to Cancel
                                                        </MenuItem>
                                                    ) : null}
                                                </>
                                            )}
                                        </Menu>
                                    </div>
                                </div>
                            )}

                            <AppBar position="static">
                                <Tabs
                                    value={value}
                                    aria-label="simple tabs example"
                                    // variant="scrollable"
                                    scrollButtons="auto"
                                >
                                    <Tab
                                        label="Invoice Details"
                                        value={0}
                                        onClick={() => handleChange(0)}
                                    />
                                    <Tab
                                        label="Transaction Details"
                                        value={1}
                                        onClick={() => handleChange(1)}
                                    />
                                    {/* <Tab
                                        label="Product Details"
                                        value={2}
                                        onClick={() => handleChange(2)}
                                    /> */}
                                </Tabs>
                            </AppBar>
                            <TabPanel value={value} index={0}>
                                <div className="invoiceInfoSection">
                                    {' '}
                                    <div className="invoiceSummary">
                                        <h3>Invoice Summary</h3>
                                        {/* <h4>
                                            <span>Invoice ID:</span>{' '}
                                            {
                                                invoiceDetails.cartValues
                                                    .common_invoice
                                            }{' '}
                                        </h4> */}
                                        <h4>
                                            <span>Invoice Date:</span>
                                            {invoiceDetails.invoiceProducts[0]
                                                ?.active === 2
                                                ? dateTimeFormatFunction(
                                                      invoiceDetails
                                                          .invoiceProducts[0]
                                                          ?.returned_date
                                                  )
                                                : dateTimeFormatFunction(
                                                      invoiceDetails.cartValues
                                                          .cart_paiddate
                                                  )}
                                        </h4>
                                        <h4>
                                            <span>Invoice Status:</span>
                                            {invoiceDetails.invoiceProducts[0]
                                                ?.active === 2
                                                ? 'Cancelled'
                                                : invoiceDetails.cartValues
                                                      .cart_paid
                                                ? 'Paid'
                                                : 'Unpaid'}
                                        </h4>
                                        <h4>
                                            <span> Total Amount: </span>
                                            <>
                                                {currencyFormat(
                                                    invoiceDetails.cartValues
                                                        .total_amount
                                                )}
                                            </>
                                        </h4>

                                        {invoiceDetails.cartValues
                                            .total_paid ? (
                                            <h4>
                                                <span> Total Paid: </span>
                                                <>
                                                    {currencyFormat(
                                                        invoiceDetails
                                                            .cartValues
                                                            .total_paid
                                                    )}
                                                </>
                                            </h4>
                                        ) : null}

                                        {invoiceDetails.cartValues
                                            .total_due_amount ? (
                                            <h4>
                                                <span> Balance: </span>
                                                <>
                                                    {currencyFormat(
                                                        invoiceDetails
                                                            .cartValues
                                                            .total_due_amount
                                                    )}
                                                </>
                                            </h4>
                                        ) : null}
                                        {/* 
                                        <h4>
                                            <span>Balances:</span>
                                            {currencyFormat(
                                                invoiceDetails?.invoiceUser[0]
                                                    ?.deposit_amount
                                            )}
                                        </h4> */}

                                        <h4>
                                            <span>Shipping Address:</span>
                                            <address>
                                                {
                                                    invoiceDetails
                                                        ?.invoiceUser[0]
                                                        ?.address1
                                                }
                                                <br />
                                                {invoiceDetails?.invoiceUser[0]
                                                    ?.address2 &&
                                                invoiceDetails?.invoiceUser[0]
                                                    ?.address2 !== '' ? (
                                                    <>
                                                        {
                                                            invoiceDetails
                                                                ?.invoiceUser[0]
                                                                ?.address2
                                                        }

                                                        <br />
                                                    </>
                                                ) : null}

                                                {invoiceDetails?.invoiceUser[0]
                                                    ?.city &&
                                                    invoiceDetails
                                                        ?.invoiceUser[0]
                                                        ?.state &&
                                                    invoiceDetails
                                                        ?.invoiceUser[0]
                                                        ?.country && (
                                                        <>
                                                            {
                                                                invoiceDetails
                                                                    ?.invoiceUser[0]
                                                                    ?.city
                                                            }
                                                            ,{' '}
                                                            {
                                                                invoiceDetails
                                                                    ?.invoiceUser[0]
                                                                    ?.state
                                                            }
                                                            ,{' '}
                                                            {
                                                                invoiceDetails
                                                                    ?.invoiceUser[0]
                                                                    ?.country
                                                            }{' '}
                                                            -{' '}
                                                            {
                                                                invoiceDetails
                                                                    ?.invoiceUser[0]
                                                                    ?.zip
                                                            }
                                                        </>
                                                    )}
                                            </address>
                                        </h4>
                                        {invoiceDetails?.invoiceProducts[0]
                                            ?.delivery_type === 'shipping' &&
                                        invoiceDetails.cartValues.cart_paid &&
                                        invoiceDetails.invoiceProducts[0]
                                            .third_shipping_shipstation_tracking ? (
                                            <>
                                                <h4>
                                                    <span>Tracking Id</span>
                                                    <a
                                                        target="_blank"
                                                        className="dgHyperlink MuiDataGrid-cellContent"
                                                        onClick={() =>
                                                            viewTrack(
                                                                invoiceDetails
                                                                    .invoiceProducts[0]
                                                                    .third_shipping_shipstation_tracking
                                                            )
                                                        }
                                                    >
                                                        {invoiceDetails
                                                            .invoiceProducts[0]
                                                            .third_shipping_shipstation_tracking
                                                            ? invoiceDetails
                                                                  .invoiceProducts[0]
                                                                  .third_shipping_shipstation_tracking
                                                            : '-'}
                                                    </a>
                                                </h4>
                                                <h4>
                                                    <span>
                                                        Shipment Status{' '}
                                                    </span>
                                                    {invoiceDetails
                                                        .invoiceProducts[0]
                                                        .third_shipping_shipstation_confirmation ==
                                                    'awaiting_shipment'
                                                        ? 'Awaiting Shipment'
                                                        : 'Done'}
                                                </h4>
                                            </>
                                        ) : null}
                                    </div>
                                    <div className="invoiceDetailsTab">
                                        <h3>Buyer Details</h3>

                                        <h4>
                                            <span> Name: </span>
                                            <a
                                                href="#"
                                                onClick={() =>
                                                    userRedirect(
                                                        invoiceDetails
                                                            ?.invoiceUser[0]
                                                    )
                                                }
                                            >
                                                {
                                                    invoiceDetails
                                                        ?.invoiceUser[0]
                                                        ?.first_name
                                                }{' '}
                                                {
                                                    invoiceDetails
                                                        ?.invoiceUser[0]
                                                        ?.last_name
                                                }
                                            </a>
                                        </h4>
                                        <h4>
                                            <span>Email:</span>
                                            {
                                                invoiceDetails?.invoiceUser[0]
                                                    ?.email
                                            }
                                        </h4>
                                        <h4>
                                            <span> Phone:</span>
                                            {
                                                invoiceDetails?.invoiceUser[0]
                                                    ?.phone
                                            }
                                        </h4>
                                    </div>
                                </div>
                                <Divider className="my-5" />
                                <div className="invoiceDetailsTab">
                                    <h3>Product Details</h3>
                                    <div className="table-responsive">
                                        {invoiceDetails.invoiceProducts
                                            .length ? (
                                            <div className="cartProducts">
                                                <div>
                                                    {invoiceDetails.invoiceProducts.map(
                                                        (data, index) => (
                                                            <CartItem
                                                                data={data}
                                                                from="invoice"
                                                                showLocation={
                                                                    true
                                                                }
                                                            />
                                                        )
                                                    )}
                                                </div>
                                            </div>
                                        ) : null}
                                    </div>
                                </div>
                            </TabPanel>

                            <TabPanel value={value} index={1}>
                                {invoiceDetails.invoiceTransactions.length ? (
                                    <>
                                        {/* <div className="row">{mapData(mapDataOptions)}</div> */}
                                        <div className="transDet d-flex justify-content-between flex-wrap">
                                            <>
                                                <table className="table">
                                                    <thead>
                                                        <tr>
                                                            {/* <th scope="col">S.No</th> */}
                                                            <th scope="col">
                                                                Transaction ID
                                                            </th>
                                                            <th scope="col">
                                                                Paid on
                                                            </th>
                                                            <th scope="col">
                                                                Method
                                                            </th>
                                                            <th scope="col">
                                                                Amount
                                                            </th>
                                                            <th scope="col">
                                                                Status
                                                            </th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {invoiceDetails.invoiceTransactions.map(
                                                            (data, index) => (
                                                                <tr key={index}>
                                                                    <td data-title="Transaction ID">
                                                                        {data.trans_id
                                                                            ? `# ${data.trans_id}`
                                                                            : '-'}
                                                                    </td>
                                                                    <td
                                                                        data-title={t(
                                                                            'paid_on'
                                                                        )}
                                                                    >
                                                                        {dateTimeFormatFunction(
                                                                            data.created_at
                                                                        )}
                                                                    </td>
                                                                    <td
                                                                        data-title={t(
                                                                            'card'
                                                                        )}
                                                                    >
                                                                        {data.payment_method ===
                                                                        'cash' ? (
                                                                            <>
                                                                                {t(
                                                                                    'cash'
                                                                                )}
                                                                            </>
                                                                        ) : data.payment_method ===
                                                                          'wallet' ? (
                                                                            'Credit'
                                                                        ) : (
                                                                            <>
                                                                                {/* {data.mk_card_number} (
                                                                    {data.card_type}) */}
                                                                                {capitalize(
                                                                                    data.payment_method
                                                                                    // t,
                                                                                )}
                                                                            </>
                                                                        )}
                                                                    </td>
                                                                    <td
                                                                        data-title={t(
                                                                            'amount'
                                                                        )}
                                                                    >
                                                                        {currencyFormat(
                                                                            data.amount
                                                                        )}
                                                                    </td>
                                                                    <td
                                                                        data-title={t(
                                                                            'payment_status'
                                                                        )}
                                                                        style={{
                                                                            color:
                                                                                data.status ===
                                                                                'success'
                                                                                    ? 'green'
                                                                                    : 'red',
                                                                        }}
                                                                    >
                                                                        {capitalize(
                                                                            data.status
                                                                        )}
                                                                    </td>
                                                                </tr>
                                                            )
                                                        )}
                                                    </tbody>
                                                </table>
                                            </>
                                        </div>
                                    </>
                                ) : null}
                            </TabPanel>

                            <TabPanel value={value} index={2}>
                                <div className="table-responsive">
                                    {invoiceDetails.invoiceProducts.length ? (
                                        <div className="cartProducts">
                                            <div>
                                                {invoiceDetails.invoiceProducts.map(
                                                    (data, index) => (
                                                        <CartItem
                                                            data={data}
                                                            from="invoice"
                                                            showLocation={true}
                                                        />
                                                    )
                                                )}
                                            </div>
                                        </div>
                                    ) : null}
                                </div>
                            </TabPanel>
                        </div>

                        {/* <ShipmentTracking
                            data={manageTracking}
                            function={toggleTrackingPopup}
                        /> */}
                        <RefundInvoice
                            data={manageRefund}
                            function={toggleRefundPopup}
                            adminId={user.admin_id}
                            invoiceID={invoiceID}
                            userId={userId}
                        />
                        <CustomDialog
                            title={'Add Tracking Numbers for this order'}
                            open={changeTrackingStatus}
                            function={changeChangeTrackStatus}
                            disableBackdropClick
                        >
                            {mapData(trackingDetails)}
                            <div className="actionWrapper">
                                <Button
                                    id="invoice_cancel"
                                    onClick={() =>
                                        setChangeTrackingStatus(false)
                                    }
                                >
                                    Cancel
                                </Button>
                                <form
                                    onSubmit={formikTracking.handleSubmit}
                                    autoComplete="nofill"
                                >
                                    <PrimaryButton
                                        id="invoice_confirm"
                                        type="submit"
                                        label="Add"
                                        disabled={disable}
                                    />
                                </form>
                            </div>
                        </CustomDialog>
                        <CustomDialog
                            title={'Change invoice status'}
                            open={changeStatus}
                            function={changeChangeStatus}
                        >
                            <h5>
                                Are you sure you want to change the status ?
                            </h5>
                            {formikSelection.values.action === 'cancel'
                                ? mapData(reasonForCancelInvoice)
                                : formikSelection.values.action === 'paid' &&
                                  mapData(paymentMethod)}
                            <div className="actionWrapper">
                                <Button
                                    id="invoice_cancel"
                                    onClick={() => setChangeStatus(false)}
                                >
                                    Cancel
                                </Button>
                                <form
                                    onSubmit={formikSelection.handleSubmit}
                                    autoComplete="nofill"
                                >
                                    <PrimaryButton
                                        id="invoice_confirm"
                                        type="submit"
                                        label="Confirm"
                                    />
                                </form>
                            </div>
                        </CustomDialog>
                        <CustomDialog
                            title="Invoice notes"
                            open={invoiceNotesStatus}
                            className="invoiceNotes"
                            function={toggleInvoiceModal}
                        >
                            <h5>
                                Add any specific information related to invoices
                                here.
                            </h5>
                            {mapData(invoiceNotes)}
                            <div className="actionWrapper">
                                <Button onClick={() => toggleInvoiceModal()}>
                                    Cancel
                                </Button>
                                <form
                                    onSubmit={formikNotesSelection.handleSubmit}
                                    autoComplete="nofill"
                                >
                                    <PrimaryButton
                                        type="submit"
                                        label="Confirm"
                                    />
                                </form>
                            </div>
                        </CustomDialog>
                    </>
                )}
            </div>
        </>
        // </FullScreenPopup>
    )
}

export default InvoiceComponent
